// Amplify configuration with fallbacks
export const amplifyConfig = {
  aws_project_region: 'eu-north-1',
  Auth: {
    Cognito: {
      userPoolId: 'eu-north-1_6XybKRbYV',
      userPoolClientId: '5muqbb5cfasltnqcfrstni2bbt',
      identityPoolId: 'eu-north-1:22db108f-edba-4608-a7d5-2224a1945311',
      loginWith: {
        email: true,
        oauth: {
          domain: 'eu-north-1n1u5rgw9s.auth.eu-north-1.amazoncognito.com',
          scopes: ['email', 'openid', 'phone'],
          redirectSignIn: ['https://www.allsaintsthirsk.org.uk/admin'],
          redirectSignOut: ['https://www.allsaintsthirsk.org.uk/'],
          responseType: 'code'
        }
      },
      signUpVerificationMethod: 'code' as const,
      userAttributes: {
        email: {
          required: true
        }
      },
      allowGuestAccess: false,
      passwordFormat: {
        minLength: 8,
        requireLowercase: true,
        requireUppercase: true,
        requireNumbers: true,
        requireSpecialCharacters: true
      }
    }
  },
  API: {
    REST: {
      allsaintsapi: {
        endpoint: 'https://tag8l7ywck.execute-api.eu-north-1.amazonaws.com/prod',
        region: 'eu-north-1'
      }
    }
  }
};